import { useState } from 'react';

import { ProjectType } from '@cartwhl/common/types';
import Image from '@cartwhl/ui/atoms/Image';
import Video from '@cartwhl/ui/atoms/Video';
import Text from '@cartwhl/ui/base/Text';
import GoButton from '@cartwhl/ui/input/GoButton';

import { projectStore, uiStore } from 'stores';

export const CreateProjectHero = () => {
  const [submitting, setSubmitting] = useState(false);

  const handleCreateMotionClick = async () => {
    if (submitting) return;
    setSubmitting(true);
    uiStore.setMotionFrontDoorMode('video');
    await projectStore.createNewProject(ProjectType.MOTION);
  };

  return (
    <div className="relative h-[495px] overflow-hidden rounded-2xl md:mx-5 md:mt-5">
      <div className="absolute inset-4 z-10 flex flex-col items-center justify-center">
        <div className="dark:bg-gray-90 flex flex-col gap-6 rounded-2xl bg-white p-6">
          <Text variant="studio/title/xl">What do you want to create?</Text>
          <div
            className="group relative h-[284px] w-full cursor-pointer overflow-hidden rounded-lg sm:w-[300px] lg:w-[376px]"
            role="button"
            tabIndex={0}
            aria-disabled={submitting}
            onClick={handleCreateMotionClick}
          >
            <Video
              src="/videos/sidekick_output.mp4"
              mode="autoplay"
              className="absolute inset-0 h-full w-full"
              crossOrigin="anonymous"
            />
            <div className="absolute inset-0 z-10 flex h-full w-full flex-col justify-between p-4">
              <Text variant="studio/title/lg" className="text-white">
                Create motion
              </Text>
              <GoButton
                className="self-center group-hover:bg-green-50"
                onClick={handleCreateMotionClick}
                loading={submitting}
              >
                Animate
              </GoButton>
            </div>
          </div>
        </div>
      </div>

      <Image
        src="/images/3d-bg.jpg"
        alt="3d-bg"
        className="absolute inset-0 h-full w-full object-cover"
      />
    </div>
  );
};
